import { z } from 'zod';
import { Dayjs } from 'dayjs';

export const TransactionAssetSchema = z.object({
  assetTypeId: z.number().optional(),
  amount: z.number().positive('Amount must be greater than 0').min(1, 'Amount must be at least 1').default(1),
});

export const CreateTransactionModalSchema = z
  .object({
    fromLocationId: z.number().min(1, 'From location is required').optional(),
    toLocationId: z.number().min(1, 'To location is required').optional(),
    date: z.custom<Dayjs>(),
    carrierId: z.number().optional(),
    documentNumber: z.string().optional(),
    referenceNumber: z.string().optional(),
    notes: z.string().optional(),
    assets: z.array(TransactionAssetSchema).optional(),
  })
  .superRefine((data, ctx) => {
    // Validate fromLocationId
    if (!data.fromLocationId || data.fromLocationId < 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'From location is required',
        path: ['fromLocationId'],
      });
    }

    // Validate toLocationId
    if (!data.toLocationId || data.toLocationId < 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'To location is required',
        path: ['toLocationId'],
      });
    }

    // Check if there's at least one asset with a valid assetTypeId
    const hasValidAsset = data.assets && data.assets.some((asset) => asset.assetTypeId && asset.assetTypeId > 0);

    if (!hasValidAsset) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Asset type is required',
        path: ['assets', 0, 'assetTypeId'],
      });
    }
  });

export type TransactionAsset = z.infer<typeof TransactionAssetSchema>;
export type CreateTransactionModalFormModel = z.infer<typeof CreateTransactionModalSchema>;
